import { useRef, useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { downloadIcon, infoIcon, todayIcon } from '../assets/images/icons';
import styles from './ListTitle.module.css';

const ListTitle = ({
  title = 'Top 100 Short-Form Video',
  onDateChange,
  selectedDate,
  minDate,
  maxDate,
  onDownload,
  disabled = false,
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [pickerPos, setPickerPos] = useState({ top: 0, right: 0 });
  const iconRef = useRef(null);
  const pickerRef = useRef(null);
  const downloadRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        pickerRef.current && !pickerRef.current.contains(e.target) &&
        iconRef.current && !iconRef.current.contains(e.target)
      ) {
        setShowPicker(false);
      }
    };
    if (showPicker) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showPicker]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (downloadRef.current && !downloadRef.current.contains(e.target)) {
        setShowDownloadMenu(false);
      }
    };
    if (showDownloadMenu) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showDownloadMenu]);

  const handleIconClick = () => {
    if (!showPicker && iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setPickerPos({
        top: rect.bottom + window.scrollY + 8,
        right: window.innerWidth - rect.right,
      });
    }
    setShowPicker((v) => !v);
  };

  const handleDateChange = (date) => {
    if (onDateChange) onDateChange(date);
    setShowPicker(false);
  };

  const handleDownloadClick = () => {
    if (disabled || !onDownload) return;
    setShowDownloadMenu((v) => !v);
  };

  const handleDownloadSelect = (format) => {
    setShowDownloadMenu(false);
    if (onDownload) onDownload(format);
  };

  const dateValue = selectedDate ? new Date(selectedDate) : null;
  const downloadDisabled = disabled || !onDownload;
  const downloadClass = downloadDisabled
    ? `${styles.downloadIcon} ${styles.downloadIconDisabled}`
    : styles.downloadIcon;

  return (
    <div className={'title ' + styles.rectangleGroup}>
      <div className={styles.rectangleContainer}>
        <div className={styles.groupInner}>
          <b className={styles.top100ShortForm}>{title}</b>
        </div>
        <div className={styles.triangle}></div>
      </div>
      <div className={styles.iconsParent}>
        <img
          ref={iconRef}
          className={styles.todayIcon}
          alt="날짜 선택"
          src={todayIcon}
          onClick={handleIconClick}
        />
        {showPicker && (
          <div
            ref={pickerRef}
            className={styles.datePicker}
            style={{ top: pickerPos.top, right: pickerPos.right }}
          >
            <DatePicker
              selected={dateValue}
              onChange={handleDateChange}
              minDate={minDate ? new Date(minDate) : undefined}
              maxDate={maxDate ? new Date(maxDate) : undefined}
              inline
            />
          </div>
        )}
        <img className={styles.infoIcon} alt="" src={infoIcon} />
        <div className={styles.downloadWrapper} ref={downloadRef}>
          <img
            className={downloadClass}
            alt="다운로드"
            src={downloadIcon}
            onClick={handleDownloadClick}
          />
          {showDownloadMenu && (
            <div className={styles.downloadMenu} role="menu">
              <button
                type="button"
                className={styles.downloadMenuItem}
                role="menuitem"
                onClick={() => handleDownloadSelect('json')}
              >
                JSON
              </button>
              <button
                type="button"
                className={styles.downloadMenuItem}
                role="menuitem"
                onClick={() => handleDownloadSelect('csv')}
              >
                CSV
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListTitle;
